module.exports = __webpack_public_path__ + "img/lotto-amb.d7e5eaca.png";